import { schemas } from '@oneappexchange/oaf-schema';
import { ListingResponse } from '~/modules/services/listing_service';

export function selectLeadTrialInformation(listing: ListingResponse): schema.oaf.LeadTrialInformation {
    const pluginType = 'listing/plugins/LeadTrialInformation' as const;
    const plugin = listing?.plugins?.find((test) => test.pluginType === pluginType);
    return (plugin?.data ?? schemas[pluginType].new()) as schema.oaf.LeadTrialInformation;
}
